class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderEl = this.querySelector("[data-slider]");
    this.slides = this.querySelectorAll("[data-slide]");
    this.prevButton = this.querySelector(".swiper-button-prev");
    this.nextButton = this.querySelector(".swiper-button-next");
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Autoplay }) => {
      const swiperParams = {
        modules: [Autoplay],
        slidesPerView: "auto",
        speed: 250,
        loop: false,
        allowTouchMove: true,
        centeredSlides: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          1024: {
            centeredSlides: false,
          },
        },
      };

      this.swiper = new Swiper(this.sliderEl, swiperParams);
    });
  }
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", ProductCarousel);
}
